// Флаги только для локальной разработки.
// Vue CLI подставляет NODE_ENV на этапе сборки: в production всегда false.

export const devSkipCaptcha = process.env.NODE_ENV === "development";
